import { debugB3React } from "../../../shared/utils/debug.js";
const debug = debugB3React("profileDisplay");
const ALLOWED_IPFS_GATEWAYS = [
    "ipfs.io",
    "gateway.pinata.cloud",
    "cloudflare-ipfs.com",
    "dweb.link",
    "nftstorage.link",
    "w3s.link",
];
const BLOCKED_HOSTNAMES = ["models.readyplayer.me", "readyplayer.me"];
function isHostnameInList(hostname, list) {
    return list.some(entry => hostname === entry || hostname.endsWith(`.${entry}`));
}
/**
 * Validates that an image URL uses an allowed schema
 * @param url - The URL to validate
 * @returns The URL if valid, null otherwise
 */
export function validateImageUrl(url) {
    if (!url)
        return null;
    try {
        // For blob URLs (from createObjectURL)
        if (url.startsWith("blob:")) {
            return url;
        }
        // For IPFS protocol URLs
        if (url.startsWith("ipfs://")) {
            return url;
        }
        // Parse URL to validate protocol and hostname
        const parsedUrl = new URL(url);
        // Only allow http and https protocols
        if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
            debug("Rejected unsafe protocol:", parsedUrl.protocol, url);
            return null;
        }
        const hostname = parsedUrl.hostname.toLowerCase();
        if (isHostnameInList(hostname, ALLOWED_IPFS_GATEWAYS)) {
            return url;
        }
        if (isHostnameInList(hostname, BLOCKED_HOSTNAMES)) {
            debug("Rejected deprecated avatar service:", hostname, url);
            return null;
        }
        return url;
    }
    catch (error) {
        // Invalid URL format
        debug("Invalid image URL format:", url, error);
        return null;
    }
}
export function getProfileDisplayInfo(profile) {
    const { type: originalType, details } = profile;
    let type = originalType;
    if (originalType === "siwe") {
        type = "EOA";
    }
    // Default display info
    let displayInfo = {
        title: details.email || details.phone || details.address || "Unknown",
        subtitle: `Connected with ${type}`,
        imageUrl: null,
        initial: (type.charAt(0) || "U").toUpperCase(),
        type,
    };
    // Handle specific providers
    switch (type) {
        case "x":
            displayInfo = {
                title: details.name || details.username || "Unknown",
                subtitle: details.username ? `@${details.username}` : "X Account",
                imageUrl: validateImageUrl(details.profileImageUrl),
                initial: "X",
                type,
            };
            break;
        case "farcaster":
            displayInfo = {
                title: details.name || details.username || "FID:" + details?.fid || "Unknown",
                subtitle: details.username ? `@${details.username}` : "Farcaster Account",
                imageUrl: validateImageUrl(details.pfpUrl || details.profileImageUrl),
                initial: "F",
                type,
            };
            break;
        case "google":
            displayInfo = {
                title: details.name || details.email || "Unknown",
                subtitle: details.email || "Google Account",
                imageUrl: validateImageUrl(details.picture || details.profileImageUrl),
                initial: "G",
                type,
            };
            break;
        case "discord":
            displayInfo = {
                title: details.username || details.name || "Unknown",
                subtitle: "Discord Account",
                imageUrl: validateImageUrl(details.profileImageUrl),
                initial: "D",
                type,
            };
            break;
        case "email":
            displayInfo = {
                title: details.email || "Unknown",
                subtitle: "Email Account",
                imageUrl: null,
                initial: "E",
                type,
            };
            break;
        case "phone":
            displayInfo = {
                title: details.phone || "Unknown",
                subtitle: "Phone Number",
                imageUrl: null,
                initial: "P",
                type,
            };
            break;
    }
    return displayInfo;
}
